<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>


                <!-- header info -->
                <v-row class="pa-4" style="align-items: center;">
                    <h3>New claim</h3>
                    <span class="ml-4" style="color: #1976d2; background-color: rgba(25, 118, 210, 0.1); border: 1px solid #1976d2; border-radius: 8px; padding: 4px 10px; display: inline-flex; align-items: center;">
                        <v-icon color="#1976d2" size="18" class="mr-2">mdi-information</v-icon>{{ claim_description }}
                    </span>
                </v-row>
                <v-row><v-divider></v-divider></v-row>
                <v-row class="pl-4 mt-6">
                    <vat_headers :huov_encrid="huov_encrid" />
                </v-row>
                <v-row class="mt-6 mb-6"><v-divider></v-divider></v-row>

                <selections :reportedby="reportedby" :hosm_gebr="hosm_gebr" :claim_ins="claim_ins" :hosm_smct_sel="hosm_smct_sel"
                            :customerInformed="customerInformed" :customerLiable="customerLiable" :depositPaid="depositPaid" @updateData="updateData"/>

                <v-card fluid flat class="mt-3">
                    <hokl_hosm_components title="Claim components" :components="components" @updateData="updateData" />
                </v-card>
                
                <v-row>
                    <v-col cols="12" class="pr-6">
                        <v-form v-model="hosm_valid">
                            <v-textarea v-model="hsmr_text" rows="3" required label="Damage text" v-bind:rules="descriptionRules">{{ hsmr_text }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>
                
                <v-card fluid flat class="mt-0 pr-6">
                    <hokl_hosm_links :links="links" @updateData="updateData"/>
                </v-card>
                
                <v-row>
                    <v-col cols="12" class="pr-6">
                        <v-textarea v-model="hosm_memo" rows="3" label="Internal memo">{{ hosm_memo }}</v-textarea>
                    </v-col>
                </v-row>

                <v-card-actions style="height: 60px;">
                    <div v-if="error_message !== ''" style="background-color: #fecaca; padding: 3px; width: 100%; display: flex; align-items: center; margin-right: 30px;">
                        <v-icon color="red" class="ml-3 mb-auto mt-1">mdi-close-circle</v-icon>
                        <div style="color:red; padding-left: 20px; padding-right: 20px;">{{ error_message }}</div>
                    </div>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!hosm_valid" v-on:click="addHosm()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>

    </v-dialog>
</template>

<script>

import vat_headers from '@/components/huov/hosm/vat_header.vue'
import hokl_hosm_components from '@/components/huov/ui/hokl_hosm_components.vue';
import hokl_hosm_links from '@/components/huov/ui/hokl_hosm_links.vue';
import selections from '@/components/huov/hosm/ui/screen_selections.vue';

export default {
    props: {
            huov_encrid: String,
            claim_description: String
    },
    components: {
        vat_headers,    
        hokl_hosm_components,
        hokl_hosm_links,
        selections        
    },
    data() {
        return {
            dialog: false,
            hosm_encrid: null,
            hosm_valid: false,
            gebr_code:'',
            hosm_gebr:'',    
            hsmr_text: '',
            hosm_memo: '',
            hsmr_smst: 'new',
            claim:'',
            claim_opened:'',
            attachments:0,
            mails:0,
            hosm_smct_sel: [],
            hosm_smct: [],
            reporters: [],
            links:[],
            reportedby: '',
            claim_ins: '',
            customerInformed: false,
            customerLiable: false,
            depositPaid: false,    
            components:[], 
            descriptionRules: [v => !!v || "A description / value is required"],
            error_message: '',            
        }
    },   
    methods: {
        open() {
            this.hosm_memo = '';
            this.hsmr_text = '';
            this.reportedby = '';
            this.customerInformed = false;
            this.customerLiable = false;
            this.depositPaid = false;
            this.hosm_gebr = '';
            this.hosm_smct_sel = [];
            this.links = [];
            this.claim_ins = '';
            this.components = [{key: 0, description: '', amount: ''}]; 
            this.dialog = true;
            this.error_message = '';
        },
        addHosm() {
            this.$axios
                .post("ares/json/ares/huov/hosm/addHosmv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHosm"
                    },
                    addHosm: {
                        huov_encrid: this.huov_encrid,
                        hsmr_text: this.hsmr_text,
                        hsmr_smst: this.hsmr_smst,
                        hosm_memo: this.hosm_memo,
                        hosm_gebr: this.hosm_gebr,
                        claimedAmount: this.totCompAmount,
                        paidAmount: '',
                        leniencyAmount: '',
                        selected_smct: this.hosm_smct_sel,
                        reportedby: this.reportedby,
                        customerInformed: this.customerInformed,
                        customerLiable: this.customerLiable,
                        depositPaid: this.depositPaid,
                        links: this.links,
                        components: this.components,
                        claim_ins: this.claim_ins
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.error_message = res.data.error.message;
                        setTimeout(() => {
                            this.error_message = '';
                        }, 5000);
                    } else {
                        this.$emit('updateData', 'refresh');
                        this.dialog = false;
                    }
                });
        },
        updateData(data){
            this[data.field] = data.value;
        },	        
    }
}
</script>

<style scoped>
</style>